"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var FormattedPreview_1 = require("./FormattedPreview");
var PreviewNumberRow = function (_a) {
    var previewNumber = _a.previewNumber, format = _a.format, separators = _a.separators;
    return (react_1.default.createElement("div", { className: "gd-measure-format-extended-preview-row" },
        react_1.default.createElement("div", { className: "gd-measure-format-extended-preview-number" },
            react_1.default.createElement("span", null, previewNumber)),
        react_1.default.createElement(FormattedPreview_1.FormattedPreview, { previewNumber: previewNumber, format: format, separators: separators, className: "s-number-format-preview-formatted gd-measure-format-extended-preview-formatted" })));
};
var PreviewRows = function (_a) {
    var _b = _a.previewNumbers, previewNumbers = _b === void 0 ? [0, 1.234, 1234.567, 1234567.891] : _b, format = _a.format, separators = _a.separators;
    return (react_1.default.createElement(react_1.default.Fragment, null, previewNumbers.map(function (previewNumber) { return (react_1.default.createElement(PreviewNumberRow, { previewNumber: previewNumber, separators: separators, key: previewNumber, format: format })); })));
};
exports.default = PreviewRows;
//# sourceMappingURL=PreviewRows.js.map